import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter as AppRouter,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';

import { removeSplashscreen, showSplashscreen } from '../helpers/browser';

import Login from '../pages/Login';
import PasswordReset from '../pages/PasswordReset';
import DefaultLayout from './layouts/Layout';
import Slideshow from '../pages/Slideshow';

import { checkSession } from '../helpers/api';
import { setUserData } from '../store/actions/authentication';

// ---
// Main route component
const Router = ({ setUserDataAction, isUserLogged }) => {
  useEffect(() => {
    // Set app loading class
    showSplashscreen();
    const checkUserAuthentication = async () => {
      try {
        const result = await checkSession();
        // If result is empty object {}, treat as no session and set null
        // Otherwise set the user data
        const userData = result && Object.keys(result).length > 0 ? result : null;
        setUserDataAction(userData);
        removeSplashscreen();
      } catch (err) {
        console.error('Error trying to check session', err);
        setUserDataAction(null);
        removeSplashscreen();
      }
    };

    checkUserAuthentication();
  }, [setUserDataAction]);

  return (
    <AppRouter>
      <Routes>
        <Route
          path="/login"
          element={isUserLogged ? <Navigate to="/" replace /> : <Login />}
        />
        <Route path="/reset_password" element={<PasswordReset />} />
        <Route path="/reset_password/:token" element={<PasswordReset />} />
        <Route path="/slideshow" element={<Slideshow />} />
        <Route path="/*" element={<DefaultLayout />} />
      </Routes>
    </AppRouter>
  );
};

export default connect(
  ({ authentication }) => ({
    isUserLogged: authentication.logged,
    isSessionChecked: authentication.sessionChecked,
  }),
  { setUserDataAction: setUserData },
)(Router);
